var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    attrs: {
      src: "https://images.qmai.cn/s12416/images/2021/08/02/ba5b4194f2857a4a.png",
      alt: "暂无数据图",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }